import { gql } from '@apollo/client'

export const acceptAdvisorConnection = gql`
  mutation acceptAdvisorConnection($token: String!) {
    acceptAdvisorConnection(token: $token) {
      id
      status
      currentStep
    }
  }
`

export const acceptAdvisorConnectionById = gql`
  mutation acceptAdvisorConnectionById($flowId: Int!) {
    acceptAdvisorConnectionById(flowId: $flowId) {
      id
      status
      currentStep
    }
  }
`

export const declineAdvisorConnection = gql`
  mutation declineAdvisorConnection($flowId: Int!) {
    declineAdvisorConnection(flowId: $flowId) {
      id
      status
      currentStep
    }
  }
`

export const donorInviteAdvisor = gql`
  mutation donorInviteAdvisor($input: DonorInviteAdvisorInput!) {
    donorInviteAdvisor(input: $input) {
      success
      message
      flow {
        id
        status
        currentStep
        targetEmail
        metadata
        expiresAt
        createdAt
      }
    }
  }
`

export const donorResendAdvisorInvite = gql`
  mutation donorResendAdvisorInvite($flowId: Int!) {
    donorResendAdvisorInvite(flowId: $flowId) {
      id
      status
      currentStep
      expiresAt
    }
  }
`

export const donorCancelAdvisorInvite = gql`
  mutation donorCancelAdvisorInvite($flowId: Int!) {
    donorCancelAdvisorInvite(flowId: $flowId) {
      id
      status
      currentStep
    }
  }
`

export const donorReissueAdvisorInvite = gql`
  mutation donorReissueAdvisorInvite($flowId: Int!) {
    donorReissueAdvisorInvite(flowId: $flowId) {
      success
      message
      flow {
        id
        status
        currentStep
        targetEmail
        metadata
        expiresAt
        createdAt
      }
    }
  }
`

export const initiateCharityOnboarding = gql`
  mutation initiateCharityOnboarding($charityId: String!, $charityInviteId: Int!) {
    initiateCharityOnboarding(charityId: $charityId, charityInviteId: $charityInviteId) {
      id
      status
      currentStep
    }
  }
`
